import React from 'react';
import ReactDOM from 'react-dom';
import { toJS } from 'mobx';
import SplashScreen from 'common/components/SplashScreen';
import StatusText from 'common/components/SplashScreen/StatusText';

// global style imports
import 'semantic-ui-css/semantic.min.css';

import { clearStorage } from './common/services/localstorage';

const appType = process.env.REACT_APP_TYPE,
  isDevelop = process.env.NODE_ENV === 'development';

isDevelop && (window.toJS = toJS);

document.addEventListener('keydown', function (event) {
  // clear localstorage when SHIFT + TAB is pressed
  if (event.keyCode === 9 && event.shiftKey) {
    clearStorage();
  }
});

function getImport() {
  switch (appType) {
    case 'OV':
      return import('./OsebniVpogled/App');

    case 'JV':
    case 'EV':
    default:
      return import('./EvidencaVrednotenja/App');
  }
}

const RootComponent = React.lazy(() => getImport());

const RootAsyncComponent = props => (
  <React.Suspense
    fallback={<SplashScreen withLoader={true} component={<StatusText text="Aplikacija se nalaga..." />} />}
  >
    <RootComponent {...props} />
  </React.Suspense>
);

ReactDOM.render(<RootAsyncComponent />, document.getElementById('root'));
